const currencyFormatter = new Intl.NumberFormat({
    style: 'currency',
    currency: 'THB',
    maximumFractionDigits: 0,
  });
  
  export default currencyFormatter;